import { CoreMicroarchitecture } from "@/types/api/cores";

export type TierLimits = {
	DynamicInstructionCount: number | null;
	ConcurrentTaskCount: number | null;
	ConcurrentBuildCount: number | null;
	CloudStorageBytes: number | null;
	DataDriveCount: number | null;
	BucketCount: number | null;
	GatewayCount: number | null;
	DataSourceCount: number | null;
	PlotCount: number | null;
	RegistryStorageBytesMaximum: number | null;
	CoreCount: number | null;
	CorePrecisionBits: number | null;
	CoreReferenceQuality: number | null;
	CoreMemorySizeBytesMaximum: number | null;
	ProCoreVariants: boolean;
	RepositoryCount: number | null;
	APIAccessCount: number | null;
	KeyCount: number | null;
	AuditableZeroDataRetention: boolean;
	DedicatedSingleTenancyPrivateServerOption: boolean;
	CoreAvailableMicroarchitectures: CoreMicroarchitecture[];
	ExecutionTimeInMillisecondsCount: number | null;
	BuildTimeInMillisecondsCount: number | null;
};

export type TierCatalogEntry = {
	Tier: string;
	Limits: TierLimits;
};

const tierLimitMembers: Record<keyof TierLimits, null> = {
	DynamicInstructionCount: null,
	ConcurrentTaskCount: null,
	ConcurrentBuildCount: null,
	CloudStorageBytes: null,
	DataDriveCount: null,
	BucketCount: null,
	GatewayCount: null,
	DataSourceCount: null,
	PlotCount: null,
	RegistryStorageBytesMaximum: null,
	CoreCount: null,
	CorePrecisionBits: null,
	CoreReferenceQuality: null,
	CoreMemorySizeBytesMaximum: null,
	ProCoreVariants: null,
	RepositoryCount: null,
	APIAccessCount: null,
	KeyCount: null,
	AuditableZeroDataRetention: null,
	DedicatedSingleTenancyPrivateServerOption: null,
	CoreAvailableMicroarchitectures: null,
	ExecutionTimeInMillisecondsCount: null,
	BuildTimeInMillisecondsCount: null,
};

export const TIER_LIMIT_KEYS = Object.keys(tierLimitMembers);
